module.exports = __webpack_public_path__ + "static/media/covi_phy_tem_bar.81dfda6c.png";